import react, { useEffect, useState } from "react";
import CustomInput from "../../../../Component/BasicComponents/CustomInput";
import { Btn } from "../../../../AbstractElements";
import RouteDropdown from "../../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import {
  useAddOutletMapping,
  useOutletCategoryTypes,
  useOutletMappingById,
  useOutletParent,
  useUpdateOutletMapping,
} from "../hooks/useCustomer";
import PaginatedRouteDropdown from "../../../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper";
import { getOutletParent } from "../hooks/CustomerRepository";
import { getAllPriceBook } from "../../../ProductCatalogue/PriceBookRepo";
interface prop {
  mode: "add" | "edit";
  modalClose: () => void;
  initialData?: Record<string, any>;
  OutletId?: number;
}

const MappingModal: React.FC<prop> = ({
  mode,
  modalClose,
  initialData,
  OutletId,
}) => {
  const [categoryType, setCategoryType] = useState();
  const [name, setName] = useState<{ id: any; label: any } | undefined>(undefined);
  const [pricebook, setPricebook] = useState<{ id: any; label: any } | undefined>(undefined);
const [isDefault, setIsDefault] = useState<boolean>(false);


  const { data: getOutletMapping } = useOutletMappingById({
    enabled: mode == "edit",
    params: {
      outletMappingId: initialData?.MappingId,
    },
  });

  console.log("getoutletbyid", getOutletMapping?.data);

  const { data: getCategoryType } = useOutletCategoryTypes({
    enabled: true,
  });

useEffect(() => {
  if (mode === "edit" && getOutletMapping?.data) {
    const data = getOutletMapping.data;

    setName({
        id: data.outletMapping.PrimaryOutletId,
        label: data.outletMapping.PrimaryOutletName,
      });
    setCategoryType(data?.outletMapping?.CategoryType || "");

    if(data?.outletMapping?.Isdefault==1){
      setIsDefault(true)
    }else{
      setIsDefault(false)
    }
   

    if (data?.outletMapping?.PricebookId && data?.outletMapping?.PricebookName) {
      setPricebook({
        id: data.outletMapping.PricebookId,
        label: data.outletMapping.PricebookName,
      });
    } else {
      setPricebook(undefined); // or null, based on your default state
    }
  }
}, [getOutletMapping, mode]);


const {mutate:addMapping}=useAddOutletMapping();
const {mutate:updateMapping}=useUpdateOutletMapping()


const handleSubmit = (e: React.FormEvent) => {
  e.preventDefault();

  const payload:any = {
    outletId: OutletId,
    primaryOutletId: name?.id,
    pricebookId: pricebook?.id,
    categoryType: categoryType,
    isDefault: isDefault?1:0,
  };

  if (mode === "edit") {
        payload.outletMappingId = initialData?.MappingId;
    updateMapping(
      {
        reqBody: payload,
        param: { outletMappingId: initialData?.MappingId },
      },
      {
        onSuccess: () => modalClose(),
      
      }
    );
  } else {
    addMapping(payload, {
      onSuccess: () => modalClose(),
   
    });
  }
};


  const formatOptions = (dataObj: Record<string, string> = {}) =>
    Object.keys(dataObj || {}).map((key) => ({ id: key, label: dataObj[key] }));


  return (
    <form onSubmit={handleSubmit}>
      <div className="container-fluid">
        <div className="col">
          <PaginatedRouteDropdown
            DropdownHeading="Primary Name"
            initialSelectedOptions={name}
            fetchOptions={async (page: any, search: any) => {
              const res = await getOutletParent({
                page,
                limit: 10,
                search: search || "",
                outletId: OutletId,
              });
              return Object.keys(res?.data?.OutletParentData || []).map(
                (key) => ({
                  id: key,
                  label: res?.data?.OutletParentData[key],
                })
              );
            }}
            placeholder="Enter Primary Name"
            onChange={(val: any) => setName(val)}
          />
        </div>

        <div className="col">
          <RouteDropdown
            DropdownHeading="Category Type"
            value={categoryType}
            onChange={(value: any) => setCategoryType(value)}
            options={formatOptions(getCategoryType?.data) || []}
          />
        </div>

        <div className="col">
          <PaginatedRouteDropdown
            DropdownHeading="Price Book"
            initialSelectedOptions={pricebook}
            fetchOptions={async (page: any, search: any) => {
              const res = await getAllPriceBook({
                page,
                limit: 10,
                search: search || "",
              });
              return (res?.data?.data || []).map((item: any) => ({
                id: item.PricebookId,
                label: item.PricebookName,
              }));
            }}
            placeholder="Enter Price Book"
            onChange={(val: any) => setPricebook(val)}
          />
        </div>
        <div className="form-check mt-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="isDefault"
            checked={isDefault}
            onChange={(e) => setIsDefault(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="isDefault">
            isDefault
          </label>
        </div>

        {/* Buttons */}
        <div className="d-flex justify-content-start gap-2 mt-2">
          <Btn
            style={{ backgroundColor: "#43B9B2", color: "white" }}
            type="submit"
          >
            {mode === "add" ? "Submit" : "Update"}
          </Btn>
          <Btn
            type="button"
            onClick={modalClose}
            style={{ backgroundColor: "#F9FAFC", color: "#000" }}
          >
            Cancel
          </Btn>
        </div>
      </div>
    </form>
  );
};

export default MappingModal;
